import { actionTypes as baseActionTypes } from "../reduxBundle";

const actionTypes = {
  RECEIVE_STUDENT_PARENTS: baseActionTypes.RECEIVE_MANY,
  RECEIVE_STUDENT_PARENT: baseActionTypes.RECEIVE_ONE,
  DELETE_STUDENT_PARENT: baseActionTypes.DELETE
};

export default actionTypes;
